import React from 'react'

const MyAccountForm = ({ children, buttons }) => {
  return (
    <div className="myaccount-form">
      <div className="myaccount-form__fieldsets">{children}</div>
      <p className="myaccount-form__cta-box">{buttons}</p>
    </div>
  )
}

export default MyAccountForm
